import React from "react"
import { DefaultLayout } from "src/components/Layout"
import { Auth } from "src/features/auth"
import { FetchCicCsv } from "src/features/fetch-cic-csv/components/FetchCicCsv"

const FetchCicCsvPage: React.VFC = () => {
  return (
    <DefaultLayout>
      <Auth>
        <FetchCicCsv />
      </Auth>
    </DefaultLayout>
  )
}

export default FetchCicCsvPage
